/**
 * Signed-in product icon sizes. Pair with Lucide (default stroke) or the
 * API-catalog Hugeicons wrappers — do not invent `size-[15px]` or other
 * one-off pixel sizes.
 *
 * Scale: `docs/architecture/product-typography.md`.
 */
export const ICON = {
  sm: 'size-3',
  md: 'size-3.5',
  default: 'size-4',
} as const
